import { mapState } from 'vuex';
import {
  bill_time_pup_tips_sw,
  bill_time_pup_tips_ck,
} from '@/omega/business/bill';

export default {
  computed: {
    ...mapState({
      openTimeObjMixin: ({ common }) => common.openTimeObj,
    }),
    showGlobalOpenTimeMsgMixin() {
      return this.openTimeObjMixin && !this.openTimeObjMixin.isOpen;
    },
    globalOpenTimeMsgContentMixin() {
      return this.openTimeObjMixin?.tip || '';
    },
  },
  methods: {
    async checkOpenTimeMixin({ event_type }) {
      return new Promise((resolve) => {
        if (!this.showGlobalOpenTimeMsgMixin) {
          resolve(true);
        } else {
          this.$confirm(
            this.globalOpenTimeMsgContentMixin,
            this.$t('Entrega_order__sndC'),
            {
              confirmButtonText: this.$t('Entrega_order__ZAuG'),
              showCancelButton: false,
              type: 'error',
              callback: (action) => {
                resolve(false);
                bill_time_pup_tips_ck(event_type);
              },
            }
          );
          bill_time_pup_tips_sw(event_type);
        }
      });
    },
  },
};
